import HttpRequestService from "./HttpRequestService";

const FaqService = {};

const getAllCntrlName = "GetFAQList";

//API for get all data
FaqService.getFaqList = function () {
    return HttpRequestService.get(getAllCntrlName);
}

export default FaqService;